import { render } from "./InventoryHeader.vue?vue&type=template&id=8c08bdb6"
import script from "./InventoryHeader.vue?vue&type=script&lang=js"
export * from "./InventoryHeader.vue?vue&type=script&lang=js"
script.render = render

export default script